/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { ApiErrorActions, TrackApiErrorParams } from './ApiErrors.meta';
import { SCREEN_NAME } from '../constants';

export default {
  [ApiErrorActions.API_ERROR]: (params: TrackApiErrorParams) => ({
    code: params.code,
    category: `social|${params.category}`,
    description: params.description,
    functionality: `social|${params.functionality}`,
    label: params.label,
    screenName: SCREEN_NAME.homeV2,
  }),
};
